export default __webpack_public_path__ + "static/media/IMG_2753cropped.a0fc64f1.jpeg";